<template>
  <div>
    <!-- MODO “TELA NORMAL”: formulário + botão -->
    <div v-if="!printMode">
      <h6>Despesas por Período</h6><p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <label>Data Início:</label>
          <input type="date" v-model="dataInicioLocal" class="form-control" />
        </div>
        <div class="col-auto">
          <label>Data Fim:</label>
          <input type="date" v-model="dataFimLocal" class="form-control" />
        </div>
        <div class="col-auto align-self-end">
          <button @click="abrirPrint" class="btn btn-primary">Executar</button>
        </div>
      </div>
    </div>

    <!-- MODO “IMPRESSÃO/PRINT”: só exibe tabela com total -->
    <div v-else>
      <p class="text-center" style="font-size: 14px;">
        ( {{ globalUtils.formatarData(dataInicio) }} a {{ globalUtils.formatarData(dataFim) }} )
      </p>

      <div v-if="loading">Carregando…</div>
      <div v-else-if="resultados.length">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>REFIL</th>
              <th>DESCRIÇÃO</th>
              <th class="valor-cell">VALOR</th>
              <th class="text-center">FORMA DE PAGAMENTO</th>
              <th class="text-center">DATA VENCIMENTO</th>
              <th class="text-center">DATA PAGAMENTO</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, idx) in resultados"
              :key="item.data_vencimento + '-' + item.descricao + '-' + idx"
            >
              <td>{{ item.refil }}</td>
              <td>{{ item.descricao }}</td>
              <td class="valor-cell">{{ formatarMoeda(item.valor) }}</td>
              <td class="text-center">{{ item.forma_pagamento }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_vencimento) }}</td>
              <td class="text-center">{{ globalUtils.formatarData(item.data_pagamento) }}</td>
            </tr>
          </tbody>
          <!-- ADICIONA O RODAPÉ COM TOTAL -->
          <tfoot>
            <tr>
              <td colspan="2"><strong>Total</strong></td>
              <td class="valor-cell text-right">
                <strong>{{ formatarMoeda(total) }}</strong>
              </td>
              <td colspan="3"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else>
        <p>Nenhum registro encontrado para este período.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'


const props = defineProps({
  printMode: { type: Boolean, default: false },
  dataInicio: String,
  dataFim: String,
  printTitle: { type: String, default: 'Despesas por Período' },
  subtitle:   { type: String, default: '' }
})

const router = useRouter()

// Estados locais (modo “tela normal”)
const dataInicioLocal = ref('')
const dataFimLocal    = ref('')

// Estados de resultado (modo “print”)
const loading     = ref(false)
const resultados  = ref([])
const total       = ref(0)  // <— guarda o total

// Se for printMode, buscar resultados já em onMounted()
onMounted(async () => {
  if (!props.printMode) return
  if (!props.dataInicio || !props.dataFim) return

  loading.value = true
  try {
    const res = await axios.get(
      '/gestao/relatorios/despesas/despesas-por-periodo',
      {
        params: {
          dataInicio: props.dataInicio,
          dataFim:    props.dataFim
        }
      }
    )
    // O back-end agora devolve { items: [...], total: 1234.56 }
    resultados.value = Array.isArray(res.data.items) ? res.data.items : []
    total.value       = parseFloat(res.data.total) || 0
  } catch (e) {
    console.error('Erro ao buscar despesas por período (print):', e)
    resultados.value = []
    total.value      = 0
  } finally {
    loading.value = false
  }
})

// Função chamada ao clicar em “Executar” no modo normal
function abrirPrint() {
  if (!dataInicioLocal.value || !dataFimLocal.value) return

  // 2) Formatar as datas para “DD/MM/YYYY”
  const inicioFormatado = globalUtils.formatarData(dataInicioLocal.value)
  const fimFormatado    = globalUtils.formatarData(dataFimLocal.value)

  // 3) Montar o subtitle completo, incluindo período
  const subtitle = `( ${inicioFormatado} a ${fimFormatado} )`


  router.push({
    path: `/gestao/relatorios/print/despesas-por-periodo`,
    query: {
      title:      'Despesas por Período',
      dataInicio: dataInicioLocal.value,
      dataFim:    dataFimLocal.value,
      subtitle:   subtitle   // envia o subtitle já com o período
    }
  })
}

function formatarMoeda(num) {
  if (num == null) return ''
  return Number(num).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.valor-cell {
  text-align: right !important;
}
.text-right {
  text-align: right !important;
}
</style>
